export const SAM_TYPES = {
    ALL : 'all',
    TIZEN : 'tizen',
    WEAR : 'wear'
    
}

export const BROWSER_TYPES = {
    CHROME: "chrome",
    SAFARI: "safari",
    FIREFOX: "firefox"
}